<template>
  <v-col cols="12">
    <v-form ref="changeDateForm">
      <base-card>
        <v-card-title>
          Cambio de Fecha en Documentos
        </v-card-title>
        <v-card-text>
          <v-row v-can="'Selector Compañias'">
            <v-col cols="12" sm="4">
              <v-select
                ref="cliente"
                v-model="data.IdCompania"
                :items="detailClients"
                item-text="text"
                item-value="id"
                label="Compañia"
                prepend-inner-icon="mdi-sitemap"
                :error="companySelectorError"
                :rules="[validateCompanyField]"
                :error-messages="helperSelectorText"
                @change="handleSelectChange"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          class="search-field"
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2 btn-primary"
                @click="checkCompanyField"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="searchIfIsAdmin">
            <v-col
              cols="12"
              sm="4"
            >
              <v-switch
                v-model="data.configStatus"
                :label="`${data.configStatus ? '(Activo) Permite cambio de fecha en documentos' : '(Inactivo) NO permite cambio de fecha en documentos'}`"
                hide-details
                inset
              />
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model.number="data.configDays"
                label="Días de antigüedad"
                type="number"
                prepend-inner-icon="mdi-calendar-range"
                :rules="formRules"
                :disabled="!data.configStatus"
                hint="Número de días hacia atrás permitidos para cambio de fecha"
                persistent-hint
              />
            </v-col>

            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2 btn-primary"
                @click="validateConfigData"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="loadingConfig"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                {{ loadingMessage }}
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                v-show="showAlert"
                :type="alertType"
                text
              >
                {{ alertMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script>

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

export default {
  name: 'ChangeDateDocuments',

  data() {
    const userData = getUserData()
    const roles = JSON.parse(localStorage.getItem('role') || '[]')
    const isGeneralAdmin = roles.includes('General-Admin') || roles.includes('General')

    return {
      data: {
        configStatus: false,
        configDays: 0,
      },
      searchIfIsAdmin: false,
      search: '',
      errorMessages: '',
      formHasErrors: null,
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
      loadingConfig: false,
      loadingMessage: '',
      formRules: [
        (v) => v !== null && v !== undefined && v !== '' || 'Este campo es requerido',
        (v) => v >= 0 || 'El valor debe ser mayor o igual a 0',
        (v) => v <= 90 || 'El valor máximo permitido es 90 días',
        (v) => Number.isInteger(Number(v)) || 'Solo acepta números enteros'
      ],
      companySelectorError: false,
      helperSelectorText: '',
      firstTime: true,
      isAdmin: !isGeneralAdmin,
      isGeneralAdmin: isGeneralAdmin,
      userIdCompania: userData.idcompania,
    }
  },

  computed: {
    statusResponseUpdateChangeDateConfig() {
      return this.$store.state.changeDateDocuments.statusSetChangeDate
    },
    statusResponseGetChangeDateConfig() {
      return this.$store.state.changeDateDocuments.statusGetChangeDate
    },
    detailClients() {
      if (this.isAdmin) {
        return (
          this.$store.state.changeDateDocuments.listClients.Mensaje || []
        )
          .filter((compania) => compania.active === 1)
          .filter((compania) =>
            compania.name.toLowerCase().includes(
              this.search.toLowerCase()
            )
          )
          .map((compania) => ({
            ...compania,
            text: `[${compania.id}] ${compania.name}`,
          }));
      }

      return (this.$store.state.changeDateDocuments.listClients.Mensaje || []).filter(
        (compania) => compania.id === this.userIdCompania
      );
    },
  },

  created () {
    if (!this.isAdmin) {
      this.loadingConfig = true
      this.loadingMessage = 'Consultando configuración...'
      this.getChangeDateConfig()
      this.searchIfIsAdmin = true
    }
    this.getListClients()
  },

  watch: {
    '$store.state.changeDateDocuments.changeDateConfig': {
      handler(data) {
        if (data && data.CambioAutomatico !== undefined) {
          this.data.configStatus = data.CambioAutomatico === '1'
          this.data.configDays = data.Dias ? parseInt(data.Dias) : 0
        }
      },
      deep: true
    },
    formHasErrors () {
      if (this.formHasErrors === false) {
        this.sendChangeDateConfig()
        this.formHasErrors = null
      }
    },
    statusResponseUpdateChangeDateConfig () {
      if(this.statusResponseUpdateChangeDateConfig === false) {
        this.loadingConfig = false
        this.alertType = 'success'
        this.alertMessage = this.$store.state.changeDateDocuments.changeDateConfigMessage
        this.generateAlert()
        this.formHasErrors = true
        this.$store.dispatch('changeDateDocuments/setUpdateStatusResponse', null)
      } else if(this.statusResponseUpdateChangeDateConfig === true) {
        this.loadingConfig = false
        this.alertType = 'error'
        this.alertMessage = this.$store.state.changeDateDocuments.changeDateConfigMessage
        this.generateAlert()
        this.formHasErrors = true
        this.$store.dispatch('changeDateDocuments/setUpdateStatusResponse', null)
      }
    },
    statusResponseGetChangeDateConfig () {
      if(this.statusResponseGetChangeDateConfig === false) {
        this.loadingConfig = false
        this.searchIfIsAdmin = true
        this.alertType = 'success'
        this.alertMessage = this.$store.state.changeDateDocuments.changeDateConfigMessage
        this.generateAlert()
        this.$store.dispatch('changeDateDocuments/statusGetChangeDate', null)
      } else if(this.statusResponseGetChangeDateConfig === true) {
        this.loadingConfig = false
        this.searchIfIsAdmin = true
        this.alertType = 'error'
        this.alertMessage = this.$store.state.changeDateDocuments.changeDateConfigMessage
        this.generateAlert()
        this.$store.dispatch('changeDateDocuments/statusGetChangeDate', null)
      }
    }
  },

  methods: {
    async getListClients () {
      await this.$store.dispatch('changeDateDocuments/getListClients')
    },
    async getChangeDateConfig () {
      await this.$store.dispatch('changeDateDocuments/getChangeDateConfig', {
        ...this.data
      })
    },
    generateAlert () {
      this.showAlert = true
      setTimeout(() => {
        this.showAlert = false
      }, 4000)
    },
    validateConfigData () {
      this.formHasErrors = !this.$refs.changeDateForm.validate();
      if (!this.formHasErrors) {
        this.loadingConfig = true
        this.loadingMessage = 'Guardando configuración...'
      }
    },
    sendChangeDateConfig () {
      this.$store.dispatch('changeDateDocuments/updateChangeDateConfig', {
        ...this.data
      })
    },
    validateCompanyField(value) {
      if ((!value || value <= 0) && this.firstTime === false) {
        this.companySelectorError = true
        this.helperSelectorText = 'El campo no puede estar vacío.'
        return false
      } else {
        this.companySelectorError = false
        this.helperSelectorText = ''
        return true
      }
    },
    checkCompanyField() {
      this.firstTime = false
      if (this.validateCompanyField(this.data.IdCompania)) {
        this.loadingConfig = true
        this.loadingMessage = 'Consultando configuración...'
        this.getChangeDateConfig()
      }
    },
    handleSelectChange (newValue) {
      this.searchIfIsAdmin = false
    }
  }
}

</script>

<style scoped>
.btn-primary {
  background-color: rgb(204, 33, 40) !important;
  color: white !important;
}
</style>
